import { FormattedMessage } from 'react-intl'
import { Box, styled } from '@mui/material'
import { Typography } from '@carto/meridian-ds/components'
import { OnboardingChecklistProgressProps } from '../types'

const ProgressionBarRoot = styled(Box, { shouldForwardProp: (propName) => propName !== 'value' })<{ value: number }>(
  ({ theme, value }) => ({
    position: 'relative',
    backgroundColor: theme.palette.action.hover,
    marginTop: theme.spacing(2),
    '&, &:before': {
      height: 6,
      borderRadius: 3
    },
    '&:before': {
      content: '""',
      position: 'absolute',
      height: '100%',
      width: `${value}%`,
      top: 0,
      left: 0,
      backgroundColor: theme.palette.secondary.main,
      margin: 0
    }
  })
)

export function OnboardingChecklistHeader({ completedTotal, total }: OnboardingChecklistProgressProps) {
  const completedPercentage = (completedTotal * 100) / total

  return (
    <Box p={3}>
      <Box display="flex" alignItems="center">
        <Typography variant="subtitle1">
          <FormattedMessage id="home.onboarding.checklist.title" />
        </Typography>
        <Typography component="span" variant="overline" color="textSecondary" ml="auto">
          {`${completedTotal}/${total} `}
          <FormattedMessage id="home.onboarding.checklist.completed" />
        </Typography>
      </Box>
      <ProgressionBarRoot value={completedPercentage} />
    </Box>
  )
}

export default OnboardingChecklistHeader
